import React, { Component } from 'react';
import HeaderVTeam from './HeaderVTeam';
import HeaderHTeam from './HeaderHTeam';
import HeaderGameInfo from './HeaderGameInfo';
import './Header.css';

class Header extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let classes = "game-hero";
        if (this.props.status_num === 1) {
            classes += " game-not-active";
        } else {
            classes += " game-active";
        }
        return (
            <div className="game-headers game-post">
                <div className={classes}>
                    <HeaderVTeam team={this.props.vTeamAbb} name={this.props.vTeamName} />
                    <HeaderGameInfo
                        vTeamScore={this.props.vTeamScore}
                        hTeamScore={this.props.hTeamScore}
                        game_text={this.props.game_text}
                        start_time={this.props.start_time}
                        period={this.props.period}
                        status_num={this.props.status_num}
                        clock={this.props.clock}
                    />
                    <HeaderHTeam team={this.props.hTeamAbb} name={this.props.hTeamName} />
                </div>
            </div>
        );
    }
}

export default Header;